<p-fieldset legend="Beschäftigung" [formGroup]="berufserfahrungForm">
  <div class="flex flex-col gap-4 w-full h-full mt-2">
    <div class="flex flex-col md:flex-row gap-y-8 md:gap-x-4">
      <p-floatlabel class="w-full md:w-1/2" variant="on">
        <input id="positionsbezeichnung" [formControl]="berufserfahrungForm.controls.positionsbezeichnung" type="text" fluid pInputText appTrTrim />
        <label for="positionsbezeichnung">Positionsbezeichnung*</label>
      </p-floatlabel>
      <p-floatlabel class="w-full md:w-1/2" variant="on">
        <p-select
          inputId="beschaeftigungsart"
          [formControl]="berufserfahrungForm.controls.beschaeftigungsart"
          [options]="beschaeftigungArten"
          fluid
        />
        <label for="beschaeftigungsart">Beschäftigungsart*</label>
      </p-floatlabel>
    </div>
    <div class="flex flex-col md:flex-row gap-y-8 md:gap-x-4">
      <p-floatlabel class="w-full md:w-1/2" variant="on">
        <input id="unternehmen" class="w-full" type="text" pInputText appTrTrim [formControl]="berufserfahrungForm.controls.unternehmen" />
        <label for="unternehmen">Unternehmen</label>
      </p-floatlabel>
      <p-floatlabel class="w-full md:w-1/2" variant="on">
        <p-select inputId="branche" [options]="branches" [formControl]="berufserfahrungForm.controls.branche" class="w-full" />
        <label for="branche">Branche*</label>
      </p-floatlabel>
    </div>
    <p-floatlabel class="w-full" variant="on">
      <input id="webseite" class="w-full" type="text" pInputText appTrTrim [formControl]="berufserfahrungForm.controls.url" />
      <label for="webseite">Webseite des Unternehmens</label>
    </p-floatlabel>
    @if (
      berufserfahrungForm.controls.url.touched && berufserfahrungForm.controls.url.invalid && berufserfahrungForm.controls.url.hasError('invalidUrl')
    ) {
      <taures-message severity="error" header="Eintrag fehlt">
        Keine gültige URL. Sie muss mit <i>http://</i> oder <i>https://</i> beginnen.
      </taures-message>
    }

    <app-date-range [vonDate]="berufserfahrungForm.controls.von" [bisDate]="berufserfahrungForm.controls.bis"></app-date-range>

    <div class="flex flex-row justify-end items-end">
      <p-button icon="pi-trash" outlined label="Löschen" severity="danger" (click)="remove.emit()"></p-button>
    </div>
  </div>
</p-fieldset>
